var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9084 4.65994L9.1174 1.08435C9.05254 1.02319 8.96663 0.996701 8.88171 1.00033H3.09007C1.93739 1.00033 1 1.88457 1 2.97154V13.0285C1 14.1156 1.93755 15 3.09007 15H10.9103C12.0623 15 13 14.1156 13 13.0285V4.8715C13 4.8715 12.9997 4.87071 12.9997 4.87024C13.0003 4.7941 12.9699 4.71811 12.9084 4.65994ZM9.20933 2.0069L11.9329 4.57592H10.6727C9.8659 4.57592 9.20916 3.95668 9.20916 3.19556V2.0069H9.20933ZM10.9104 14.4088H3.09007C2.28322 14.4088 1.62682 13.7896 1.62682 13.0285V2.97154C1.62682 2.21058 2.28339 1.5915 3.09007 1.5915H8.58234V3.19556C8.58234 4.28269 9.52007 5.16709 10.6727 5.16709H12.3732V13.0285C12.3733 13.7897 11.7171 14.4088 10.9104 14.4088Z",
    fill: "#30556B",
    stroke: "#30556B",
    strokeWidth: 0.4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.655f1fa7595d9cf6984420a92d9746ff.svg";
export { ForwardRef as ReactComponent };